export const iconsSize = 45;
